import { render, staticRenderFns } from "./ImportProcessStartedNotification.vue?vue&type=template&id=2d5aedda&scoped=true&"
import script from "./ImportProcessStartedNotification.vue?vue&type=script&lang=js&"
export * from "./ImportProcessStartedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5aedda",
  null
  
)

export default component.exports